import React, { FC, forwardRef } from 'react';
import MuiMenuItem, { MenuItemProps as MuiProps } from '@material-ui/core/MenuItem';

interface MenuItemProps extends MuiProps {
    button?: true;
}

const MenuItem: FC<MenuItemProps> = forwardRef((props: MenuItemProps, ref) => {
    return <MuiMenuItem ref={ref} {...props} />;
});

MenuItem.displayName = 'MenuItem';

export type { MenuItemProps };
export default MenuItem;
